module.exports = __webpack_public_path__ + "media/images/athletes/4311-35b9f9eedbe90a855e7bb466b92ce89c.png";